import { Navigate, createBrowserRouter } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import Login from '../pages/Auth/Login';
import { lazyWithRetry } from '../utils/lazyWithRetry';

const Forget = lazyWithRetry(() => import('../pages/Auth/Forget'));
const Signup = lazyWithRetry(() => import('../pages/Auth/Signup'));
const Password = lazyWithRetry(() => import('../pages/Auth/Signup/Password'));
const NewPassword = lazyWithRetry(() => import('../pages/Auth/Signup/NewPassword'));
const AvatarUpload = lazyWithRetry(() => import('../pages/Auth/Avatar'));

export const routes = createBrowserRouter([
  // {
  //   path: '/',
  //   // element: <AuthLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <CreateProject />
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   // element: <Layout />,
  //   children: [
  //     {
  //       path: 'data-extraction/:id/:quarter/:year',
  //       children: [
  //         {
  //           index: true,
  //           element: <DataExtraction />
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'signup',
        element: <Signup />
      },
      {
        path: 'forget',
        element: <Forget />
      },
      {
        path: 'password',
        element: <Password />
      },
      {
        path: 'new-password',
        element: <NewPassword />
      },
      {
        path: 'avatar',
        element: <AvatarUpload />
      },
      {
        index: true,
        element: <Navigate to="login" />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/auth" />
  }
]);
